/**
 * package: com.inq.ui
 * class: Button
 * @extends com.inq.ui.Container
 * @constructor
 */
com.inq.ui.Button = function(_id, sources, text) {
	com.inq.ui.Container.call(this,_id);

	this._useHandCursor = false;
	this._text = text || "";

	// Building _newim first so it doesn't block the cler.gif on _img on iPad.
	if(sources) {
		for (var si = 0; si < sources.length; si++) {
			this.setUpSkin(sources[si]);
		}
	}
	var btnMarkup =  this.BTN_MARKUP_PREFIX + this._text + "</button>";
	this._div.innerHTML = this.IMG_MARKUP + this.TABLE_MARKUP + btnMarkup;
	this._skin = this._div.getElementsByTagName("img")[0];
	this._img = this._div.getElementsByTagName("button")[0];
	this._span = this._div.getElementsByTagName("td")[0];
	this._table = this._div.getElementsByTagName("table")[0];
	this._div.container = this;
	this._img.container = this;
	this._table.container = this;
	this._skin.container = this;
	this._span.container = this;/* needed for IE */
	/**
	 * @type {number} The index of current button state for the buttons with multiple state.
	 * For example, see "FontMgr" for "btnFontSize".
	 */
	this.currentState = 0;
	/**
	 * @type {Array} The list of labels describing all possible states of the button.
	 * @see {com.inq.ui.Button.prototype.initializeStateLabelList} for the detailed description of data format
	 */
	this.stateLabelList = null;

	if (com.inq.utils.Capabilities.isIphone()) {
		/**
		 * @see http://jira.touchcommerce.com/browse/RTDEV-11087
		 * @description window.popup will work only when invoked from a click event on IOS
		 */
		if (_id.includes("btnCloseChat")) {
			this._img.addEventListener('click', $bind(this, this.doClick));
		}

		this._img.ontouchend = $bind(this, this.iPhoneHandleButtonPress);
	} else {
		this._img.onmouseover = $bind(this, this.doMouseOver);
		this._img.onmouseout = $bind(this, this.doMouseOut);
		this._img.onclick = $bind(this, this.doClick);
		this._table.onclick = $bind(this, this.doClick);
	}
};

$hxClasses.extend(com.inq.ui.Container, com.inq.ui.Button, "com.inq.ui.Button");

/** softClick - performs a click event on the covering image (_img)
 *
 * Allows for a programatic way of clicking on a button.
 * @public
 * @returns nothing
 */
com.inq.ui.Button.prototype.softClick = function() {
	/** @type {Document} */
	var doc = this._div.ownerDocument;
	/** @type {?Window} */
	var win = doc.defaultView;/*  Get window from the document*/
	/** @type {Event} */
	var evnt = doc.createEvent("MouseEvents");
	evnt.initMouseEvent("click", true, true, win, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
	this._img.dispatchEvent(evnt);
};


/**
 * applyStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * private override function applyStyle():Void
 * @override
 * @private
 * @this com.inq.ui.Button
 * @return {void}
 */
com.inq.ui.Button.prototype.applyStyle = function() {
	com.inq.ui.Container.prototype.applyStyle.call(this);
	this.fixButtonSize();
	/* insert the pertinent style info for the text */
	/** @type {string} */
	var fontstyles;

	fontstyles = "background-color:transparent;width:100%;height:100%;";
	if(this.getStyle("color") != null) fontstyles += "color: " + Std.string(this.getStyle("color")) + ";";
	if(this.getStyle("fontFamily") != null) fontstyles += " font-family: " + Std.string(this.getStyle("fontFamily")) + ";";
	if(this.getStyle("fontSize") != null) fontstyles += " font-size: " + Std.string(this.getStyle("fontSize")) + "pt;";
	if(this.getStyle("textAlign") != null) fontstyles += "text-align:" + Std.string(this.getStyle("textAlign")) + ";";
	if(this.getStyle("verticalAlign") != null) fontstyles += "vertical-align:" + Std.string(this.getStyle("verticalAlign")) + ";"; else fontstyles += "vertical-align:middle;";
	this._span.style.cssText = fontstyles;
	var _id = this._div.id, _styl = this._div.style;

	if ((_id.indexOf("btnPopOut") != -1 || _id.indexOf("btnMinimize") != -1) && com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		_styl.display = "none";
	}
	if ((_id.indexOf("btnPrint") != -1) && (com.inq.utils.Capabilities.isIOSWebView() || com.inq.utils.Capabilities.isAndroidWebView())) {
		_styl.display = "none";
	}
};

/**
 *  To prevent situation when button is larger
 *  than it's container (it might occurs in cause of user agent stylesheets)
 *  we need to recalculate button size. The main idea is to reduce
 *  button size according to the difference between real button size
 *  (including paddings) and container's one.
 */
com.inq.ui.Button.prototype.fixButtonSize = function () {
	/** @type {ClientRect} */
	var btnRect = this._img.getBoundingClientRect();
	/** @type {ClientRect} */
	var parentRect = this._div.getBoundingClientRect();
	/** @type {number} */
	var heightDiff = btnRect.height - parentRect.height;
	/** @type {number} */
	var widthDiff = btnRect.width - parentRect.width;
	if (heightDiff > 0) {
		this._img.style.height = parseInt(this._img.style.height) - heightDiff + "px";
	}
	if (widthDiff > 0) {
		this._img.style.width = parseInt(this._img.style.width) - widthDiff + "px";
	}
};

/**
 * Set the given style property.
 * HTMLElement "button" doesn't support "alt" as an attribute, but support "title".
 * The "title" attribute is used for screen readers and tooltips.
 *
 * @override
 * @param name
 * @param value
 */
com.inq.ui.Button.prototype.initAttribute = function(name, value) {
	name = ("alt" == name) ? "title" : name;
	com.inq.ui.Button.__super__.prototype.initAttribute.call(this, name, value);
};


/**
 * setUpSkin
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setUpSkin(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.Button
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.Button.prototype.setUpSkin = function(val) {
	this.loadImage("upSkin",val,"width:100%;height:100%");
};


/**
 * loadImage
 *
 * $type TFun([{ name => styleName, t => TInst(String,[]), opt => false },{ name => val, t => TInst(String,[]), opt => false },{ name => elementStyle, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function loadImage(styleName:String, val:String, elementStyle:String):Void
 * @public
 * @this com.inq.ui.Button
 * @param {string}  styleName
 * @param {string}  val
 * @param {string}  elementStyle
 * @return {void}
 */
com.inq.ui.Button.prototype.loadImage = function(styleName,val,elementStyle) {
	if(this._div != null) {

		if(val == null || val == "") return;
		this.setStyle(styleName,val);

		this._backgroundImage = this.getNewImage();
		this._backgroundImage.setAttribute("style",elementStyle);

		this._backgroundImage.onload = $bind(this,this.whenLoaded);
		this._backgroundImage.src = val;
		if (com.inq.utils.Capabilities.isIpad() || com.inq.utils.Capabilities.isIphone() ) {
			var toolTip = this.styles["toolTip"];
			toolTip = !toolTip ? "" : toolTip;
			this._backgroundImage.alt = toolTip + " new image";
			this._backgroundImage.setAttribute("aria-hidden", "true");

		} else if ( com.inq.utils.Capabilities.isAndroid() || navigator.platform.toUpperCase().indexOf("MAC") >= 0 ) {
			this._backgroundImage.setAttribute("aria-hidden", "true");
		} else {
			this._backgroundImage.alt = "";
		}
		this._backgroundImage.setAttribute("tabindex", "-1");
	}
};

/**
 * onLoadImage
 *
 * $type TFun([{ name => element, t => TType(js.HtmlDom,[]), opt => false }],TDynamic(null))
 * public function onLoadImage(element:js.HtmlDom):Dynamic
 * @public
 * @this com.inq.ui.Button
 * @param {HTMLElement} element
 * @return {null}
 */
com.inq.ui.Button.prototype.onLoadImage = function(element) {
	try {
		/** @type {HTMLElement} */
		var imageElement = element;
		/** @type {HTMLElement} */
		var div = this._div;

		this._loadWidth = imageElement.width;
		this._loadHeight = imageElement.height;

		imageElement.style.height = "100%";
		imageElement.style.width = "100%";

		/* if there is no height, or there is no top AND bottom to define height, create height attribute */
		if(this.styles.height == null && (this.styles.top == null || this.styles.bottom == null)) this.styles.height = "" + Std.string(this._loadHeight);
		/* if there is no width, or there is no right AND left to define height, create width attribute */
		if(this.styles.width == null && (this.styles.left == null || this.styles.right == null)) this.styles.width = "" + Std.string(this._loadWidth);

		if(element.elementStyle != null) element.style.cssText = element.elementStyle;

		/* remove the first child, if it is an image */
		if(div.firstChild != null && div.firstChild.tagName == "IMAGE") div.removeChild(div.firstChild);
		div.insertBefore(element,div.firstChild);

		this.resize();
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {

			haxe.Log.trace("ERROR: " + Std.string(e),{ fileName : "Button.hx", lineNumber : 195, className : "com.inq.ui.Button", methodName : "onLoadImage"});
		} else throw(e);
	}
};


/**
 * setID
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * override  public function setID(val:String):Void
 * @override
 * @public
 * @this com.inq.ui.Button
 * @param {string}  val
 * @return {void}
 */
com.inq.ui.Button.prototype.setID = function(val) {
	com.inq.ui.Container.prototype.setID.call(this,val);
	/** TODO Base id's off of the real div id
	 * 	val = _div.id;
	 *  We must make sure that we fix Selenium scripts first
	 */
	if(this._skin != null) this._skin.id = Std.string(this._div.id) + "_skin";
	if(this._img != null) this._img.id = Std.string(this._div.id) + "_img";
	if(this._span != null) this._span.id = Std.string(this._div.id) + "_span";
	if(this._table != null) this._table.id = Std.string(this._div.id) + "_table";
};


/**
 * setHandCursor
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setHandCursor(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.Button
 * @param {string}  val
 * @return {null}
 */
com.inq.ui.Button.prototype.setHandCursor = function(val) {
	/** @type {string} */
	var value = val;
	switch(value.toLowerCase()) {
		case "true":
			this._useHandCursor = true;
			break;
		case "false":
			this._useHandCursor = false;
			break;
		default:
			this._useHandCursor = false;
	}
	this.useHandCursor = this._useHandCursor?"true":"false";
};


/**
 * setLabel - setter for the label attribute
 * lable for the push button,
 * Special feature is that if there are anchor tags embeded in the label
 * Then: we parse them and make them safe and add handler ...
 * ... also we position label over the click layer (behind normally)
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setLabel(val:Dynamic):Dynamic
 * @this com.inq.ui.Button
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.Button.prototype.setLabel = function(val) {
	this.label = val;
	this._span.innerHTML = val;
	this._span.setAttribute("aria-hidden", "true");

	/* See if there are any Anchors in the label
	 * If so, then change z-order so label is above clear click image
	 * Fix anchors so that they work properly in CI
	 */
	/** @type {NodeList} */
	var anchors = this._span.getElementsByTagName("A");
	var /** @type {number} */ ix;
	if(anchors != null && anchors.length > 0) {

		if(this._div.parentNode != null) this._div.insertBefore(this._img,this._table);
		var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = anchors.length;
		while(_g1 < _g) {
			var /** @type {number} */ ix1 = _g1++;
			var /** @type {*} */ anchor = anchors[ix1];
			var /** @type {Array} */ href = [anchor["href"]];
			var /** @type {Array} */ target = [anchor["target"] != null?anchor.target:"_self"];
			anchor.href = "javascript:void(0);";
			anchor.target = "_top";
			anchor.container = this;
			anchor.onclick = (function(target,href) {
				return function() {
					com.inq.flash.client.control.FlashPeer.PushToFrameset(href[0],target[0],true);
					return true;
				};
			})(target,href);
		}
	}
};


/**
 * applyAttributeMap
 *
 * @override
 */
com.inq.ui.Button.prototype.applyAttributeMap = function () {
	for (var aKey in this.attributeMap) {
		if (this.attributeMap.hasOwnProperty(aKey)) {
			switch (aKey) {
				case "aria-live":
				case "aria-hidden":
					this._div.setAttribute(aKey, this.attributeMap[aKey]);
					break;
				case "tooltip":
					this._img.setAttribute("title", this.attributeMap[aKey]);
					break;
				case "data-state-label-list":
					this.initializeStateLabelList(this.attributeMap[aKey]);
					break;
				default:
					this.getPrimaryObject().setAttribute(aKey, this.attributeMap[aKey]);
			}
		}
	}
}

/**
 * setAttribute
 *
 * @override
 */
com.inq.ui.Button.prototype.setAttribute = function (key, value) {
	switch (key) {
		case "aria-live":
		case "aria-hidden":
			this._div.setAttribute(key, value);
			break;
		case "tooltip":
			this._img.setAttribute("title", value);
			this._table.setAttribute("title", value);
			break;
		default:
			this.getPrimaryObject().setAttribute(key, value);
	}
};

/**
 * getPrimaryObject
 *
 * @override
 */
com.inq.ui.Button.prototype.getPrimaryObject = function(){
	return	this._img;
}


/**
 * buildStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * override private function buildStyle():Void
 * @override
 * @private
 * @this com.inq.ui.Button
 * @return {void}
 */
com.inq.ui.Button.prototype.buildStyle = function() {
	com.inq.ui.Container.prototype.buildStyle.call(this);
	/** type {string} */
	var cursor = (this.getStyle("useHandCursor") == "true") ? "pointer" : "default";
	this._style += "cursor: " + cursor + ";" ;
	this._span.style["cursor"] = cursor;
	this._table.style["cursor"] = cursor;
	this._img.style["cursor"] = cursor;
};

/**
 * doMouseOut
 *
 * $type TFun([],TEnum(Void,[]))
 * private  function doMouseOut()
 * @private
 * @this com.inq.ui.Button
 * @return {void}
 */
com.inq.ui.Button.prototype.doMouseOut = function() {
	/** @type {string} */
	var curskin = this._skin.src;
	if(this.upSkin != null && curskin != this.upSkin) {
		this._skin.src = this.upSkin;
		this._skin.style.height = this._div.style.height;
		this._skin.style.width = this._div.style.width;
	}
};


/**
 * doMouseOver
 *
 * $type TFun([],TEnum(Void,[]))
 * private  function doMouseOver()
 * @private
 * @this com.inq.ui.Button
 * @return {void}
 */
com.inq.ui.Button.prototype.doMouseOver = function() {
	/** @type {string} */
	var curskin = this._skin.src;
	if(this.overSkin != null && curskin != this.overSkin) {
		this._skin.src = this.overSkin;
		this._skin.style.height = this._div.style.height;
		this._skin.style.width = this._div.style.width;
	}
};

/**
 * iPhoneHandleButtonPress - call Container superclass's click handler.
 *
 * MOB-777: The minimize button requires that we call doClick to work properly, while the restore button requires
 * doClick. Since we're binding to the touchstart event on iOS, we need to dispatch to the handlers to make sure
 * the right one is called. (Calling both breaks both.)
 *
 * @return {boolean}
 */
com.inq.ui.Button.prototype.iPhoneHandleButtonPress = function (e) {
	try {
		if (this.hasEventListener(com.inq.events.MouseEvent.CLICK)) {
			/**
			 * RTDEV-16228 - This fixes the problem when chat is restored from minimized state.  What happened was the
			 * verizon page dispatched the blur event that caused our text input to lose focus and therefore the chat
			 * UI displayed incorrectly. The fix is to stop the event propagation so that we won't be affected by the
			 * blur event from the client's code.
			 */
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}
			this.doClick(e);
		}
		else {
			/*
			 * RTDEV-20325
			 * Problem: "The customer has minimized the chat" message shows up on AI twice for iphone.
			 * Solution: Test to see if the currentTarget is "btnMinimize" and whether the chat has been minimized.
			 * I observed that for the scenario described in this issue (BestBrands), chat had already minimized by
			 * onTouchStart function in ChatTextFocusMonitorImplIphoneSafari7.js. However, it is not true for
			 * att.com/shop.  Therefore, we not only need to check for the target.id but also need to make sure that
			 * the chat has not been minimized.
			 */
			if (!e || !e.currentTarget || e.currentTarget.id !== "tcChat_minimize_img" ||
				!com.inq.flash.client.control.MinimizeManager.isMinimized()) {
				this.onClick();
			}
		}
	    if (com.inq.stage.ViewportMgr.impl && com.inq.stage.ViewportMgr.impl.zoomedScreenMsgIsVisible === true) {
	      window.top.scrollTo(0,0);
	    }
		return false; // Need to return false here to cancel follow-on events.
	}
	catch (e) {
		console.log("[ MOB-777 ] ERROR in Button.iPhoneHandleButtonPress! " + e);
		return true; // Something went haywire, let the *actual* click handlers run.
	}
};

/**
 * doClick
 *
 * private function doClick()
 * @private
 * @this com.inq.ui.Button
 * @param {object} evt - event object
 * @return {void}
 */
com.inq.ui.Button.prototype.doClick = function(evt) {
	/** @type {com.inq.events.MouseEvent} */
	var ev = new com.inq.events.MouseEvent(com.inq.events.MouseEvent.CLICK, evt);
	this.dispatchEvent(ev);
};


/**
 * setOnClick
 *
 * $type TFun([{ name => whenClicked, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * override 	public function setOnClick(whenClicked:Dynamic)
 * @override
 * @public
 * @this com.inq.ui.Button
 * @param {null}  whenClicked
 * @return {void}
 */
com.inq.ui.Button.prototype.setOnClick = function(whenClicked) {
	this._img.onclick = whenClicked;
	this._table.onclick = whenClicked;
};

/**
 * getHtmlLabelObject - returns appropriate object to label for.
 *
 * public function getHtmlLabelObject():Object
 * @public
 * @this com.inq.ui.Button
 * @return {Object}
 */
com.inq.ui.Button.prototype.getHtmlLabelObject = function() {
	/** @type {?Object} */
	var labelObjet = null;
	if(typeof this._img != "undefined") {
		labelObjet = this._img
	} else {
		if(typeof this._div != "undefined") {
			labelObjet = this._div.firstChild;
		}
	}
	return labelObjet;
};

/**
 * @description setting the image focus so the google talkback can set its selection area around the button
 * @return {void}
 */
com.inq.ui.Button.prototype.setImageFocus = function()
{
	if(this._img)
		this._img.focus();
}

/**
 *  @overwrite
 */
com.inq.ui.Button.prototype.whenLoaded = function () {
	com.inq.ui.Container.prototype.whenLoaded.call(this);

	//ci gui sets iconCloserWidth programatically, since we only know the size of the title bar buttons after they load
	//( which totalled equals the icon closer width ) and from which the correct width of the drag handle is calculated, we call the function to total th
	if (com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
		window.parent.EventManager.calculateButtonContainer(this.styles.id);
	}
};

/**
 * Shows the send button and adds the possibility to navigate to it by keyboard "Tab".
 */
com.inq.ui.Button.prototype.enable = function() {
	this.setVisible(true);
};

/**
 * Hides the send button and blocks the possibility to navigate to it by keyboard "Tab".
 */
com.inq.ui.Button.prototype.disable = function() {
	this.setVisible(false);
};

/**
 * Checks that "data-state-label-list" attribute is presented on the MXML element definition.
 * If it's presented, then parse its value to fill the array (list) "this.stateLabelList".
 *
 * The following format is used:
 *      data-state-label-list='["string value of state #1", "string value of state #2", "etc."]'
 * If empty array is specified, e.g. data-state-label-list='[]', then default value is used.
 * Default value is specified in the corresponding manager.
 * For example, see "FontMgr" for "btnFontSize".
 *
 * @type {string} value of data-state-label-list attribute from the skin MXML
 */
com.inq.ui.Button.prototype.initializeStateLabelList = function(stateLabelListAttribute) {
	try {
		/** @type {Array} */
		var stateLabelList = JSON.parse(stateLabelListAttribute);
		if (Array.isArray(stateLabelList)) {
			this.stateLabelList = stateLabelList;
		} else {
			throw new Error("Incorrect format of data-state-label-list=" + stateLabelListAttribute);
		}
	} catch (e) {
		com.inq.flash.client.control.FlashPeer.logError(e.message + ", skin URL: " + com.inq.ui.SkinLoader.getSkinURL());
	}
};

/**
 * Returns the description of button state specified in MXML element definition by index.
 * @see {com.inq.ui.Button.prototype.initializeStateLabelList} for the detailed description of data format
 * @param {number} index
 * @return {?string} state description (label)
 */
com.inq.ui.Button.prototype.getStateLabelByIndex = function(index) {
	return this.stateLabelList ? this.stateLabelList[index] : null;
};

/**
 * Returns the description of current button state specified in MXML element.
 * @see {com.inq.ui.Button.prototype.initializeStateLabelList} for the detailed description of data format
 * @return {?string} state description (label)
 */
com.inq.ui.Button.prototype.getStateLabel = function() {
	return this.stateLabelList ? this.stateLabelList[this.currentState] : null;
};

/**
 * Sets corresponding title attribute from {@link stateLabelList} array
 * @see {com.inq.ui.Button.prototype.initializeStateLabelList} for the detailed description of data format
 * @param {number} index
 */
com.inq.ui.Button.prototype.setState = function(index) {
	this.currentState = index;
	if (this.stateLabelList) {
		/** @type {string} */
		var title = this.getStateLabel();
		this.setAttribute("title", title);
		this.announceStateChanging();
	}
};

/**
 * Sets default state labels, if corresponding value isn't specified in MXML element
 * @see {com.inq.ui.Button.prototype.initializeStateLabelList} for the detailed description of data format
 * @param {Array} defaultList
 */
com.inq.ui.Button.prototype.setupDefaultStateLabels = function(defaultList) {
	if (Array.isArray(this.stateLabelList)) {
		for (var i = 0; i < defaultList.length; i++) {
			/** @type {?string} */
			var curStateLabel = this.getStateLabelByIndex(i);
			if (typeof curStateLabel !== "string" || !curStateLabel.trim().length) {
				this.stateLabelList[i] = defaultList[i];
			}
		}
	}
};

/**
 * Adds aria-message to announce the purpose and the actual button state by screen readers
 */
com.inq.ui.Button.prototype.announceStateChanging = function() {
	/** @type {?string} the button title (label) to be pronounced by the screen reader application */
	var title = this.getStateLabel();
	// Since iOS12, VoiceOver announce 'title' changing, so we don't need to additionally add aria message
	if (title && !(com.inq.utils.Capabilities.isSafariVersion12() || com.inq.utils.Capabilities.isChromeiOS12())) {
		com.inq.aria.AriaMsg.addAriaMsg(title);
	}
};

/** @type {string} */
com.inq.ui.Button.prototype.BTN_MARKUP_PREFIX = "<button type=\"button\" draggable=\"false\" " +
	"style=\"border: none; position: absolute; left:0; top: 0; width: 100%; height: 100%; " +
	"background-color: transparent;\">";

/**
 * @type {string}
 * img src is set to 1x1 transparent gif to avoid invalid tag
 * ref: https://stackoverflow.com/a/13139830/438371
 */
com.inq.ui.Button.prototype.IMG_MARKUP = "<img aria-hidden=\"true\" style=\"display: none;\" alt=\"\" src=\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\"/>";

/** @type {string} */
com.inq.ui.Button.prototype.TABLE_MARKUP = "<table role=\"presentation\" " +
	"style=\"position: absolute; left: 0;top: 0;height: 100%;width: 100%; margin: auto;\">" +
	"<tr><td><div></div></td></tr></table>";
/** @type {null} */
com.inq.ui.Button.prototype._table = null;
/** @type {null} */
com.inq.ui.Button.prototype._skin = null;
/** @private @type {null} */
com.inq.ui.Button.prototype._span = null;
/** @type {null} */
com.inq.ui.Button.prototype._img = null;
/** @private @type {boolean} */
com.inq.ui.Button.prototype._useHandCursor = null;
/** @type {null} */
com.inq.ui.Button.prototype.label = null;
/** @type {null} */
com.inq.ui.Button.prototype.useHandCursor = null;
/** @type {null} */
com.inq.ui.Button.prototype.overSkin = null;
/** @type {null} */
// TODO: deprecated or broken value? no longer assigned anywhere
com.inq.ui.Button.prototype.upSkin = null;
/** @type {com.inq.ui.Button} */
com.inq.ui.Button.prototype.__class__ = com.inq.ui.Button;
